import { WidgetMetadata } from 'components/Dashboard/types';

export enum HRSpeedingWidgetsEnum {
  SpeedingReport = 'SpeedingReport',
}

export const DefaultHRSpeedingWidgets: WidgetMetadata<HRSpeedingWidgetsEnum>[] =
  [
    {
      identifier: HRSpeedingWidgetsEnum.SpeedingReport,
      shortTitle: 'Hastighet & GPS',
      longTitle: 'Hastighet & GPS-täckning',
      active: true,
    },
  ];

export const LongTitles: Record<HRSpeedingWidgetsEnum, string> =
  DefaultHRSpeedingWidgets.reduce(
    (titles, widget) => ({
      ...titles,
      [widget.identifier]: widget.longTitle,
    }),
    {} as Record<HRSpeedingWidgetsEnum, string>
  );
